// FETCH ALL PROPERTIES FROM DESPATCH_DC DETAILS
export const FETCH_DESPATCH_DC_DETAILS_REQUEST = 'FETCH_DESPATCH_DC_DETAILS_REQUEST';
export const FETCH_DESPATCH_DC_DETAILS_SUCCESS = 'FETCH_DESPATCH_DC_DETAILS_SUCCESS';
export const FETCH_DESPATCH_DC_DETAILS_FAILURE = 'FETCH_DESPATCH_DC_DETAILS_FAILURE';

// ee
// FETCH ALL PROPERTIES FROM DESPATCH_DC DETAILS
export const FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_REQUEST = 'FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_REQUEST';
export const FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_SUCCESS = 'FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_SUCCESS';
export const FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_FAILURE = 'FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_FAILURE';

// FETCH ALL PROPERTIES FROM DESPATCH_DC DETAILS
export const FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_REQUEST = 'FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_REQUEST';
export const FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_SUCCESS = 'FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_SUCCESS';
export const FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_FAILURE = 'FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_FAILURE';

// FETCH ALL PROPERTIES FROM DESPATCH_DC DETAILS BY ID
export const FETCH_DESPATCH_DC_DETAILS_BY_ID_REQUEST = 'FETCH_DESPATCH_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_DESPATCH_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_DESPATCH_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_DESPATCH_DC_DETAILS_BY_ID_FAILURE = 'FETCH_DESPATCH_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR DESPATCH_DC DETAILS
export const CREATE_DESPATCH_DC_DETAILS_REQUEST = 'CREATE_DESPATCH_DC_DETAILS_REQUEST';
export const CREATE_DESPATCH_DC_DETAILS_SUCCESS = 'CREATE_DESPATCH_DC_DETAILS_SUCCESS';
export const CREATE_DESPATCH_DC_DETAILS_FAILURE = 'CREATE_DESPATCH_DC_DETAILS_FAILURE';

// CREATE PROPERTIES FOR DESPATCH_DC DETAILS
export const CREATE_DESPATCH_DC_DETAILS2_REQUEST = 'CREATE_DESPATCH_DC_DETAILS2_REQUEST';
export const CREATE_DESPATCH_DC_DETAILS2_SUCCESS = 'CREATE_DESPATCH_DC_DETAILS2_SUCCESS';
export const CREATE_DESPATCH_DC_DETAILS2_FAILURE = 'CREATE_DESPATCH_DC_DETAILS2_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_DESPATCH_DC_DETAILS = 'CREATE_USER_FORM_DESPATCH_DC_DETAILS';

// UPDATE PROPERTIES FOR DESPATCH_DC DETAILS
export const UPDATE_DESPATCH_DC_DETAILS_REQUEST = 'UPDATE_DESPATCH_DC_DETAILS_REQUEST';
export const UPDATE_DESPATCH_DC_DETAILS_SUCCESS = 'UPDATE_DESPATCH_DC_DETAILS_SUCCESS';
export const UPDATE_DESPATCH_DC_DETAILS_FAILURE = 'UPDATE_DESPATCH_DC_DETAILS_FAILURE';

// FETCH SINGLE DESPATCH_DC_DETAILS
export const FETCH_SINGLE_DESPATCH_DC_DETAILS_REQUEST = 'FETCH_SINGLE_DESPATCH_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_DESPATCH_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_DESPATCH_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_DESPATCH_DC_DETAILS_FAILURE = 'FETCH_SINGLE_DESPATCH_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR DESPATCH_DC DETAILS
export const DELETE_DESPATCH_DC_DETAILS_REQUEST = 'DELETE_DESPATCH_DC_DETAILS_REQUEST';
export const DELETE_DESPATCH_DC_DETAILS_SUCCESS = 'DELETE_DESPATCH_DC_DETAILS_SUCCESS';
export const DELETE_DESPATCH_DC_DETAILS_FAILURE = 'DELETE_DESPATCH_DC_DETAILS_FAILURE';

export const FETCH_DESPATCH_DC_PREVIOUS_LIST_REQUEST = 'FETCH_DESPATCH_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_DESPATCH_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_DESPATCH_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_DESPATCH_DC_PREVIOUS_LIST_FAILURE = 'FETCH_DESPATCH_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const DESPATCH_DC_DETAILS_USERFORM_RESET = 'DESPATCH_DC_DETAILS_USERFORM_RESET';

export const CREATE_USER_FORM_DESPATCH_DC_EDIT_QTY = 'CREATE_USER_FORM_DESPATCH_DC_EDIT_QTY';
export const CREATE_USER_FORM_DESPATCH_DC_SECOND_GRID_EDIT_QTY = 'CREATE_USER_FORM_DESPATCH_DC_SECOND_GRID_EDIT_QTY';

export const RESET_DESPATCH_DC_EDIT_QTY_V2 = 'RESET_DESPATCH_DC_EDIT_QTY_V2';
export const RESET_DESPATCH_DC_SECOND_GRIG_EDIT_QTY_V2 = 'RESET_DESPATCH_DC_SECOND_GRIG_EDIT_QTY_V2';


export const CREATE_USER_FORM_DESPATCH_DC_GENERATE_QTY = 'CREATE_USER_FORM_DESPATCH_DC_GENERATE_QTY';